import FormattedMessage from 'I18n/components/FormattedMessage';
import { getWebhookResponseBody } from 'automation-ui-log-events/records/LogEvent/contextMapUtils';
import { ExecutionStates } from 'automation-ui-log-events/constants/LogEventConstants';
import LogEventDetailField from 'automation-ui-canvas/containers/enrollment-history/panel/selected-enrollment/LogEventDetailField';
import { jsx as _jsx } from "react/jsx-runtime";
export default function UserInputDetails({
  logEvent
}) {
  const webhookResponse = JSON.parse(getWebhookResponseBody(logEvent));
  if (logEvent.executionState === ExecutionStates.ASYNC) {
    const {
      outputFields: {
        prompt
      }
    } = webhookResponse;
    return /*#__PURE__*/_jsx(LogEventDetailField, {
      header: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.enrollmentHistory.panel.selected-enrollment.user-input.promptFieldLabel"
      }),
      children: prompt
    });
  } else if (logEvent.executionState === ExecutionStates.SUCCESS) {
    const {
      outputFields: {
        userResponse
      }
    } = webhookResponse;
    return /*#__PURE__*/_jsx(LogEventDetailField, {
      header: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.enrollmentHistory.panel.selected-enrollment.user-input.userResponseFieldLabel"
      }),
      children: userResponse
    });
  } else {
    // TODO
    return null;
  }
}